import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { RutterCompany } from './rutter-company.entity';
import { RutterCompanyConnectionStatus } from './rutter-company-connection.status.enum';

export class CreateRutterCompanyDto extends Omit(RutterCompany, [...BaseEntityFieldsArray, 'status']) {
    status?: RutterCompanyConnectionStatus;
}
